<app-nav></app-nav>
<ngbd-carousel-basic></ngbd-carousel-basic>
<app-cards></app-cards>
<app-banner></app-banner>
<app-contact></app-contact>
<app-footer></app-footer>